import {
    showExpDate,
    hideExpDate
} from './_expDate';
import {
    displayDynamicShippingAlert
} from './_displayDynamicShippingAlert';
import {
	getCardBrand2
} from './_getCardBrand2';

const isDillardsChargeSelected2 = () => {
    var dillardsChargeCC = 'Dillards Charge',
        dillardsPrivateLabelCC = 'Dillards Private Label',
        mySplitResult = $('select[name=paymentMethod]').val().split(","),
        ccBrand = mySplitResult[1];
		if(ccBrand.trim() == dillardsChargeCC.trim() || ccBrand.trim() == dillardsPrivateLabelCC.trim() || ccBrand.trim() == 'noCardSelected') {
            hideExpDate();
        }
        else {
             showExpDate();
 		}
    $('#cardNumber').val("");
    $('#card-expire-month').val("");
    $('#card-expire-year').val("");
    $('#pay_data_cvvNumber').val("");
};

const isDillardsChargeEntered2 = () => {
    var getCardNumber = $('#cardNumber').val();
    var removeSpaces = getCardNumber.replace(/\s/g, '');
    var trimmedVal =  removeSpaces.trim();
    $('#cardNumber').val(trimmedVal);
    var acct = $("#cardNumber").val(),
        cardBrand = getCardBrand2(acct);
    if (cardBrand == "Dillards Charge") $('#Dillards_Charge_SelectCard2').prop('selected', true);
    else if (cardBrand == "Dillards Mastercard") $('#Dillards_Mastercard_SelectCard2').prop('selected', true);
    else if (cardBrand == "Dillards AMEX Charge") $('#Dillards_AMEX_Charge_SelectCard2').prop('selected', true);
    else if (cardBrand == "Dillards Private Label") $('#Dillards_Private_Label_SelectCard2').prop('selected', true);
    else if (cardBrand == "Discover") $('#Discover_SelectCard2').prop('selected', true);
    else if (cardBrand == "VISA") $('#VISA_SelectCard2').prop('selected', true);
    else if (cardBrand == "Master Card") $('#Master_Card_SelectCard2').prop('selected', true);
    else if (cardBrand == "AMEX") $('#AMEX_SelectCard2').prop('selected', true);
    if (cardBrand != "Dillards Charge" && cardBrand != "Dillards Private Label") {
        var oldDAMEXBin = new RegExp("^374354"),
            oldDillardsBin = new RegExp("^604587");
        if (acct.match(oldDAMEXBin) != null || acct.match(oldDillardsBin) != null) {
            var oldGEBinModal = $("#OldGEbinModal:visible").length == 0;
            if ((acct.match(oldDillardsBin) != null) && oldGEBinModal) $('#oldGEbinModalClick').click();
            if ((acct.match(oldDAMEXBin) != null) && oldGEBinModal) $('#oldGEbinModalClick2').click();
        } else $(".checkout-actions .btn").show();
    } 
    if(cardBrand != ''){
    	if (cardBrand != "Dillards Charge" && cardBrand != "Dillards Private Label") {
    		showExpDate();
    	}else{
    		hideExpDate();
    	}
    }
    if (acct == '') {
        hideExpDate();
        $('select[name=paymentMethod]').prop('selectedIndex', 0);
        isDillardsChargeSelected2();
    }
    $('#generic-error-message').remove();
	$('#cardNumber').parents('.form-group').removeClass('has-error');
};

const isSavedCardDillardsCharge2 = () => {
    var dillardsChargeCC = 'Dillards Charge',
        dillardsPrivateLabel = 'Dillards Private Label',
        mySplitResult = document.QuickCheckoutCC2.savedcards.value.split(","),
        ccBrand = mySplitResult[1],
        profileFormViewURL = $('#profileFormViewURL').html(),
        isDillardsCC = ccBrand.trim() == dillardsChargeCC.trim() || ccBrand.trim() == dillardsPrivateLabel.trim(),
        isExpired = mySplitResult[6];        
    if (!isDillardsCC) {
        var cardMonth = parseInt(mySplitResult[2]),
            cardYear = parseInt(mySplitResult[3]),
            currentYear = $("#currentYear").html(),
            expiredYear = cardYear < currentYear,
            expiredMonth = (cardYear == currentYear) && (cardMonth < $('#currentMonth').html()),
           // message = 'The expiration date for your saved credit card of ' + mySplitResult[5].trim() + ' is invalid. Please visit <a href="' + profileFormViewURL + '"> My Quick Checkout Profile </a> and update the expiration date on your card and try again.';
           message = 'The expiration date for your saved credit card of ' + mySplitResult[5].trim() + ' is invalid. Please update the expiration date on your card and try again.';
        if (isExpired == 'true'){
            displayDynamicShippingAlert(message, 'danger');
            $("#updateDateWrapper").show();
        } else{
            $("#updateDateWrapper").hide();
        }
    } else {
        $("#updateDateWrapper").hide(); 
    }
};

export {
    isDillardsChargeEntered2,
    isDillardsChargeSelected2,
    isSavedCardDillardsCharge2
}
